import Icon from '@katalon-studio/katalon-ui/Icon';
import React from 'react';
import colors from '../../../scss/colors.scss';

function ThumbsDownIcon({ color, textSize, type }) {
  return <Icon
    type={type}
    name="fa-thumbs-down"
    textSize={textSize}
    sx={{
      color,
    }}
    boundingSize={null}
    color={null}
  />;
}

ThumbsDownIcon.defaultProps = {
  color: colors.gray9,
  textSize: '1rem',
  type: 'fa-regular',
};

export default ThumbsDownIcon;
